// extracted by mini-css-extract-plugin
export default {"container":"nTOEE9","zoomIn":"sqUyGm","zoomOut":"C_JY0G","zoom-button":"RZQnmg","zoomButton":"RZQnmg"};